'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DEFAULT_DATE_PICKER_FORMAT: ()=>DEFAULT_DATE_PICKER_FORMAT,
    DatePicker: ()=>DatePicker
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../InputButton/index.cjs");
const Footer_cjs_namespaceObject = require("../CustomComponents/Footer.cjs");
const DatePickerDesktop_cjs_namespaceObject = require("../DatePickerDesktop/DatePickerDesktop.cjs");
const helpers_cjs_namespaceObject = require("../helpers/helpers.cjs");
const OverlayCalendar_cjs_namespaceObject = require("../OverlayCalendar/OverlayCalendar.cjs");
const DEFAULT_DATE_PICKER_FORMAT = 'ccc, MMM d';
function DatePicker({ mode = 'single', handleCalendarChange, footerLeftNode, subHeading, components: initialComponents, label, selected, displayNights, isMobile, isOpen: isCalendarOpen = false, customDateFormat, onMonthChange: onMonthChangeProp, placeholder, isDisabled, errorMessage, helperText, errorText, inputRef, ...restProps }) {
    const [isOpen, setIsOpen] = (0, external_react_namespaceObject.useState)(isCalendarOpen);
    let initialFormattedDates = subHeading ?? '';
    if (selected && !subHeading) initialFormattedDates = (0, helpers_cjs_namespaceObject.getFormattedDates)({
        dates: selected,
        dateFormat: DEFAULT_DATE_PICKER_FORMAT,
        displayNights
    });
    const [formattedDates, setFormattedDates] = (0, external_react_namespaceObject.useState)(initialFormattedDates);
    const [selectedDates, setSelectedDates] = (0, external_react_namespaceObject.useState)(selected);
    const handleCalendarDates = (0, external_react_namespaceObject.useCallback)((newDates, triggerDate)=>{
        setSelectedDates(newDates);
        setFormattedDates((0, helpers_cjs_namespaceObject.getFormattedDates)({
            dates: newDates,
            dateFormat: customDateFormat ?? DEFAULT_DATE_PICKER_FORMAT,
            displayNights
        }));
        handleCalendarChange(newDates, triggerDate);
        if ((0, helpers_cjs_namespaceObject.shouldAutoClose)(mode, newDates)) setIsOpen(false);
    }, [
        handleCalendarChange,
        displayNights,
        mode,
        customDateFormat,
        setIsOpen
    ]);
    const onMonthChange = (month)=>{
        onMonthChangeProp?.(month);
    };
    const handleCalendarDisplayState = (0, external_react_namespaceObject.useCallback)((val)=>{
        setIsOpen(val);
    }, []);
    const handleOpen = (0, external_react_namespaceObject.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const value = subHeading || formattedDates || '';
    const subHeadingValue = subHeading || formattedDates || label || '';
    const renderInput = (0, external_react_namespaceObject.useCallback)((props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            "data-testid": "date-picker-input",
            ...props,
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.InputButton, {
                ref: inputRef,
                className: "w-full",
                label: label,
                value: value,
                iconLeft: 'calendar_month',
                size: 'lg',
                placeholder: placeholder,
                isDisabled: isDisabled,
                errorMessage: errorMessage,
                helperText: helperText,
                errorText: errorText
            })
        }), [
        errorMessage,
        errorText,
        helperText,
        inputRef,
        isDisabled,
        label,
        placeholder,
        value
    ]);
    const components = {
        ...initialComponents,
        Footer: ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Footer_cjs_namespaceObject.Footer, {
                footerLeftNode: footerLeftNode,
                handleFooterCallBack: handleCalendarDisplayState
            })
    };
    if (isMobile) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            renderInput({
                onClick: handleOpen
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(OverlayCalendar_cjs_namespaceObject.OverlayCalendar, {
                mode: mode,
                handleCalendarChange: handleCalendarDates,
                open: isOpen,
                handleDrawerState: handleCalendarDisplayState,
                selected: selectedDates,
                subHeading: subHeadingValue,
                onMonthChange: onMonthChange,
                ...restProps
            })
        ]
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DatePickerDesktop_cjs_namespaceObject.DatePickerDesktop, {
        mode: mode,
        open: isOpen,
        handlePopOverOpenState: handleCalendarDisplayState,
        inputNode: renderInput,
        title: label,
        selected: selectedDates,
        handleCalendarChange: handleCalendarDates,
        components: components,
        onMonthChange: onMonthChange,
        ...restProps
    });
}
exports.DEFAULT_DATE_PICKER_FORMAT = __webpack_exports__.DEFAULT_DATE_PICKER_FORMAT;
exports.DatePicker = __webpack_exports__.DatePicker;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DEFAULT_DATE_PICKER_FORMAT",
    "DatePicker"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
